import { useAppContext } from '../../../../app/Context';
import { usePollContext } from '../../Context';
import { getIsPollPublished } from '../helpers';

const usePollQuestion = () => {
  const { isPresenting } = useAppContext();

  const { poll } = usePollContext();

  const isPollPublished = getIsPollPublished(poll);
  const pollQuestion = poll?.questionsById?.[poll.questions[0]];

  return { isPollPublished, isPresenting, pollQuestion };
};

export default usePollQuestion;
